import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './button.css'

const prefix = 'mc-button--';

const Button = ({ children, bgColor,bordered, variant, size, full, className, Icon, iconRight, disabled=false,...props }) => {
	const [ variantClass, setVariantClass ] = useState('');
	const [ sizeClass, setSizeClass ] = useState('');

	useEffect(
		() => {
			console.log('variant effect', variant);
			const variantClass = `${prefix}${bordered ? 'bordered' : 'solid'}${variant && variant !== 'primary'
				? `-${variant}`
				: ''}`;
			setVariantClass(variantClass);
		},
		[ bordered, variant ]
	);

	useEffect(
		() => {
			const sizeClass = `${prefix}${size ? size : 'm'}`;
			setSizeClass(sizeClass);
		},
		[ size ]
	);
	const getVariantBgColor=()=>{
		switch (variant){
			case "secondary":
				return "#666666";
				break;
			case "tertiary":
				return "#46A610";
				break;
			case "shadow":
				return "white"
			case "info":
				return "#007BB4"
				break;
			default:
				return ""
		}
	}

	const getVariantTextColor=()=>{
		switch (variant){
			case "secondary":
				return "white";
				break;
			case "tertiary":
				return "";
				break;
				case "info":
					return "white";
					break;
			case "shadow":
				return "#188803"
			default:
				return ""
		}
	}

	const icon = Icon ? <Icon style={{color:getVariantTextColor()}}className="mc-button__icon  mc-button__icon--m" /> : null;
	const isIconButton = Icon && !children;


	
	return (
		<button
			className={classNames('over-button',
				'mc-button',
				sizeClass,
				variantClass,
				{ [`${prefix}full`]: full, 'mc-button--square': isIconButton },
				className
			)}
			style={{backgroundColor: getVariantBgColor(),
				boxShadow: variant=="shadow"?"0px 4px 4px 0px #00000040":""

			}}
			{...props}
			disabled={disabled}
		>
			{!iconRight && icon}
			{children && <span style={{color:getVariantTextColor()}}className="mc-button__label">{children}</span>}
			{iconRight && icon}
		</button>
	);
};

Button.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.arrayOf(PropTypes.node), PropTypes.node ]),
	bordered: PropTypes.bool,
	full: PropTypes.bool,
	variant: PropTypes.string,
	className: PropTypes.string,
	size: PropTypes.string,
	Icon: PropTypes.func,
	iconRight: PropTypes.bool,
};

Button.defaultProps = {
	children: null,
	bordered: false,
	full: false,
	variant: '',
	className: '',
	size: '',
	Icon: null,
	iconRight: false,
};

export default Button;
